import {useTranslation} from "react-i18next";
import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import ApiService from "../../../core/service/api-service";
import {useEffect} from "react";
import DataGrid from "../../../core/components/data-grid/DataGrid";
import userColumns from "./UserColumns";

// Çevrimiçi süzgeci seçiliyken liste kendi kendine tazelenir: presence uygulama loglarından gelir
// ve dakikalar içinde eskir; yönetici "kim şu an bağlı" sorusuna elle yenilemeden cevap alabilmeli.
const ONLINE_REFRESH_MS = 30000;

export default function UserGrid({onSelect})
{
    const {t} = useTranslation();
    const {setDataGridProps, queryModel, setData, setPaginationResult} = useDataGrid();

    // silent: otomatik tazelemede global yükleme göstergesi çıkmasın, ekran zıplamasın.
    const initGridData = async (silent = false) => {
        const response = await ApiService.UserManager.GetUserDataGrid(queryModel, silent)
        setPaginationResult(response.pagination);
        setData(response.data)
    }

    useEffect(() => {
        initGridData()
    }, [queryModel.updateKey])

    useEffect(() => {
        if (queryModel.filter?.online === null || queryModel.filter?.online === undefined)
            return;

        const timer = setInterval(() => initGridData(true), ONLINE_REFRESH_MS);
        return () => clearInterval(timer);
    }, [queryModel])

    useEffect(() => {
        setDataGridProps({
            rowKey: 'id',
            columns: userColumns(t, onSelect)
        })
    }, [])

    return (
        <>
            {/*
                Grid adı 'user' → 'user-v2': kolon seçimi localStorage'da grid adıyla saklanıyor ve
                kayıtlı listede olmayan YENİ kolonlar gizleniyor. Ad değişmezse daha önce kolon
                seçimi kaydetmiş yöneticilerde "Çevrimiçi" kolonu hiç görünmezdi.
            */}
            <DataGrid
                name={'user-v2'}
            />
        </>
    )
}
